// dependencies
import React from "react";

// components
import { Avatar, AvatarSize, Tooltip } from "@performyard/py-components";

// utils
import toEmployeeUrl from "../../utils/URLs/Employee";

import Link from "../Link";
// styles
import css from "./AvatarGroup.module.scss";

export const getAvatarEntry = (
	hasLinks: boolean,
	canExpand: boolean,
	employeeNameTooltip: boolean,
	employee: { _id: string; name: string },
	style = {},
	size: AvatarSize,
	border = true
) => {
	const avatarContent = (
		<div style={style} className={`${css.avatarContainer} ${border ? "" : css.noBorder}`}>
			<Avatar size={size} dangerouslySetClassName={css.avatar} id={employee._id} name={employee.name} />
		</div>
	);
	if (employeeNameTooltip) {
		const withTooltip = (
			<Tooltip content={employee.name} placement="top" asChild>
				{avatarContent}
			</Tooltip>
		);
		if (!canExpand) {
			return (
				<Link href={`/employee-page/${employee._id}`} forceHardReload={true}>
					{withTooltip}
				</Link>
			);
		}
		return withTooltip;
	}
	if (hasLinks && !canExpand) {
		return (
			<Link href={toEmployeeUrl(employee._id)} forceHardReload={true}>
				{avatarContent}
			</Link>
		);
	}
	return avatarContent;
};
